export enum ActionType {
  EMAIL = 'EMAIL',
  EMAIL_DATA = 'EMAIL_DATA',
  OTRS = 'OTRS',
  OTRS_WEBSERVICE = 'OTRS_WEBSERVICE',
  WEBHOOK = 'WEBHOOK',
  NO = 'NO'
}
